import Vue from 'vue';
import Errors from './error';
/* eslint-disable no-underscore-dangle */
export default Vue.extend({
  data() {
    return {
      originalData: {},
      apiErrors: new Errors(),
      valid: false,
      submitting: false,
      config: {
        transformToPayload: this.defaultTransformToPayload,
        transformToForm: this.defaultTransformToForm,
      },
    };
  },

  created() {
    const data = {};
    for (let key in data) {
      this[key] = data[key];
    }
    Object.keys(this.$data).forEach((key) => {
      if (['originalData', 'config', 'apiErrors', 'valid', 'submitting'].indexOf(key) === -1) {
        data[key] = this[key];
      }
    });

    this.$data.originalData = data;

    const option = this.$options;
    const optionArray = Object.keys(this.$data.config);
    optionArray.forEach((op) => {
      if (Object.prototype.hasOwnProperty.call(option, op)) {
        this.config[op] = option[op];
      }
    });
  },
  computed: {
    /**
     * Disable submit button helper
     */
    disabled() {
      return this.submitting || this.$v.$error;
    },

    /**
     * Get payload for API request
     * @returns {Object}
     */
    payload() {
      const data = {};
      if (this.originalData) {
        Object.keys(this.originalData).forEach((key) => {
          data[key] = this[key];
        });
      }

      const payload = this.config.transformToPayload(data);
      if (this.config.setComputedPayloadBackToForm) {
        Object.keys(payload).forEach((key) => {
          if (key in this.$data) {
            // prevent vue warning assigning reactive data to vue in runtime
            window.Vue.set(this.$data, key, payload[key]);
          }
        });
      }
      return payload;
    },
  },
  methods: {
    defaultTransformToPayload(payload) {
      return payload;
    },
    defaultTransformToForm(payload) {
      return payload;
    },

    /**
     * Check form field has a rule error
     * @param field
     * @param key
     * @returns {boolean}
     */
    hasValidationError(field, key) {
      return key in this.$v[field] && !this.$v[field][key];
    },

    /**
     * Reset the form fields.
     */
    reset() {
      // if (this.config.resetAfterSuccess) {
      Object.keys(this.originalData).forEach((key) => {
        this[key] = this.originalData[key];
      });
      // }

      // this.apiErrors.clear();
    },

    resetToOriginal() {
      Object.keys(this.originalData).forEach((key) => {
        this[key] = this.originalData[key];
      });
    },

    rollback() {
      Object.keys(this.originalData).forEach((key) => {
        this[key] = window._.cloneDeep(this.originalData[key]);
      });
    },

    /**
     * Send a POST request to the given URL.
     * .
     * @param {string} url
     */
    post(url) {
      return this.submit('post', url);
    },

    /**
     * Send a PUT request to the given URL.
     * .
     * @param {string} url
     */
    put(url) {
      return this.submit('put', url);
    },

    /**
     * Send a PATCH request to the given URL.
     * .
     * @param {string} url
     */
    patch(url) {
      return this.submit('patch', url);
    },

    /**
     * Send a DELETE request to the given URL.
     * .
     * @param {string} url
     */
    delete(url) {
      return this.submit('delete', url);
    },

    /**
     * Submit the form.
     *
     * @param {string} requestType
     * @param {string} url
     */
    submit(requestType, url) {
      this.submitting = true;

      // window.Vue.$loading.open();

      return new Promise((resolve, reject) => {
        window.axios[requestType](url, this.payload)
          .then((response) => {
            this.onSuccess(response.data);
            // console.log(response.data);
            this.submitting = false;
            // window.Vue.$loading.close();
            resolve(response.data);
          })
          .catch((error) => {
            console.log(error);
            this.onFail(error);
            this.submitting = false;
            // window.Vue.$loading.close();
            reject(error);
          });
      });
    },

    /**
     * Handle a successful form submission.
     *
     * @param {object} data
     */
    onSuccess(/* data */) {
      // alert(data.message); // temporary
      // this.$v.$reset();
      this.reset();
      // this.apiErrors.clear();
    },

    /**
     * Handle a failed form submission.
     *
     * @param {object} errors
     */
    onFail() {
      console.log('on fail');
    },
  },
});
